import { render } from "./haircareDiagTip.vue?vue&type=template&id=3ee4a04c"
import script from "./haircareDiagTip.vue?vue&type=script&lang=js"
export * from "./haircareDiagTip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__